var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-files"},[_c('div',{staticClass:"cp-files-header"},[_c('r-title',{attrs:{"type":"subtitle-2"}},[_vm._v("Файлы и ссылки")])],1),_c('files',{attrs:{"id":_vm.id,"source_id":_vm.sourceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }